import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthenticationHomeComponent } from './components/authentication-home/authentication-home.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { EnterPasswordLoginComponent } from './components/enter-password-login/enter-password-login.component';
import { SetPasswordCloudComponent } from './components/set-password-cloud/set-password-cloud.component';

const routes: Routes = [
  {
    path:'',
    redirectTo:"/auth/login",
    pathMatch:'full'
  },
  {
    path: 'login',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: AuthenticationHomeComponent,
    data: {
    },
    children: [

      {
        path: 'login',
        component: LoginComponent,
        data: {
          browserTitle: 'Login to NCache Cloud Portal'
        },
        pathMatch: 'prefix'
      },
      {
        path: 'reset_password',
        component: ResetPasswordComponent,
        data: {
          browserTitle: 'Reset Password of NCache Cloud Portal'
        },
      },
      {
        path: 'forgot_password',
        component: ForgotPasswordComponent,
        data: {
          browserTitle: 'Reset Password from NCache Cloud Portal'
        },
      },
      {
        path: 'enter_passsword_login',
        component: EnterPasswordLoginComponent,
        data: {
          browserTitle: 'Login to NCache Cloud Portal'
        },
      },

      {
        path: 'set_password_cloud',
        component: SetPasswordCloudComponent,
        data: {
          browserTitle: 'Set Password from NCache Cloud Portal'
        }
      },
      {
        path: 'signin/subscriptions',
        component: SignInComponent,
        data: {
          breadcrumb: 'Register User',
          breadcrumbStopNav: true,
          browserTitle: 'Register on NCache Cloud Portal'
        }
      }
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AuthenticationRoutingModule { }
